import React from "react";

import MultiMissionLogo from "./MultiMissionLogo";

const MultiMissionExplainer = () => {
  return (
    <>
      <div
        className="ln-u-margin-bottom"
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "row",
          maxHeight: "40px",
        }}
      >
        <MultiMissionLogo />
      </div>
    </>
  );
};

export default MultiMissionExplainer;
